import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {SptAudioService} from '@spout/web-global/data-access';

@Component({
  selector: 'spt-help-getting-started-collaboration-content',
  templateUrl: './help-getting-started-collaboration-content.component.html',
  styleUrls: ['./help-getting-started-collaboration-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpGettingStartedCollaborationContentComponent {
  constructor(private sptAudioService: SptAudioService) {}
  refresh(): void {
    this.sptAudioService.refreshAudioDeviceList().subscribe(() => {});
  }
}
